<div class="collapse-panel">
  <div class="collapse-panel__title">
    <bdr-icon (click)="onClick($event)" [icon]="isExpanded ? 'ico-down' : 'ico-next'" size="14"></bdr-icon>
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="collapse-panel__content" *ngIf="isExpanded">
    <ng-content select="[content]"></ng-content>
  </div>
</div>